import React from "react";
import Sidebar from "./Sidebar";
import { Toaster } from "../components/ui/sonner";

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white/95 arc-bg">
      <Sidebar />
      <main className="md:ml-64 min-h-screen">
        <div className="px-6 md:px-10 py-8 max-w-[1600px]">{children}</div>
      </main>
      <Toaster theme="dark" richColors position="top-right" />
    </div>
  );
};

export default Layout;
